module.exports = __webpack_public_path__ + "static/media/sync2.c9d76566.svg";